export default __webpack_public_path__ + "a2465cac2d8bfff09495803bab7a1939.png";